import {createSelector} from 'reselect';
import {getApplepayConfiguration, getSettings} from './selectors';

export default createSelector(
  [getSettings, getApplepayConfiguration],
  (settings, applepayConfiguration) => {
    const defaultSupportedNetworks = ['visa', 'masterCard'];
    if (settings?.should_use_dynamic_applepay_supported_networks && applepayConfiguration) {
      const {supportedNetworks} = applepayConfiguration;
      return supportedNetworks || defaultSupportedNetworks;
    }
    
    return defaultSupportedNetworks;
  },
);
